function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#108AEC",
  fill: "#108AEC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.5 10.5v3l-4.5-3H.5V.5h15v10z"
}));
function SvgCommentBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14
  }, props), _ref);
}
export default SvgCommentBlue;